// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import Vuex from 'vuex'
import VueResource from 'vue-resource'
import VueReactiveCookie from 'vue-reactive-cookie'
import sass from './sass/app.sass'
import iconFont from './sass/iconfont.scss'

// Global components
import VueUploadcare from 'vue-uploadcare'
import Icon from '@/globalComponents/Icon'
import Button from '@/globalComponents/Button'
import ContentGroup from '@/globalComponents/ContentGroup'

Vue.use(sass)
Vue.use(iconFont)
Vue.use(VueResource)
Vue.use(Vuex)
Vue.use(VueReactiveCookie)
Vue.config.productionTip = false

// Global components
Vue.component('uploadcare-com', VueUploadcare)
Vue.component('icon-com', Icon)
Vue.component('button-com', Button)
Vue.component('contentgroup-com', ContentGroup)

const store = new Vuex.Store({
  strict: true,
  state: {
    changesFound: false,
    userInfo: {
      name: '',
      organisation: ''
    },
    feeds: [],
    currentFeed: null
  },
  mutations: {
    userInfo (state, {name, organisation}) {
      const userInfo = state.userInfo

      userInfo.name = name
      userInfo.organisation = organisation
    },
    wipeUserInfo (state) {
      const userInfo = state.userInfo

      userInfo.name = ''
      userInfo.organisation = ''
    },
    feeds (state, feeds) {
      state.feeds = feeds
    },
    addNewType (state, typeData) {
      state.feeds.push(typeData)
    },
    updateFeedHeader (state, {value, key, feedGroupIndex, feedIndex}) {
      const feeds = state.feeds
      const feedGroup = feeds[feedGroupIndex]
      const feed = feedGroup[feedIndex]
      feed[key] = value
    },
    updateFeedGroupHeader (state, {value, key, feedGroupIndex, feedIndex}) {
      const feeds = state.feeds
      const feedGroup = feeds[feedGroupIndex]
      const feed = feedGroup[feedIndex]
      const input = feed[0]
      input[key] = value
    },
    updateDataType (state, {property, value, index}) {
      state.feeds[state.currentFeed][0].template[index][property] = value
    },
    addDataType (state) {
      state.feeds[state.currentFeed][0].template.push({
        name: '',
        type: 'text'
      })
    },
    deleteDataType (state, inIndex) {
      state.feeds[state.currentFeed][0].template.splice(inIndex, 1)
    },
    deleteFeedGroup (state, {feedGroupIndex}) {
      state.feeds.splice(feedGroupIndex, 1)
    },
    toggleFeedGroupPublic (state, {feedGroupIndex, isPublic}) {
      state.feeds[feedGroupIndex][0].public = isPublic
    },
    deleteFeed (state, {feedGroupIndex, feedIndex}) {
      state.feeds[feedGroupIndex].splice(feedIndex, 1)
    },
    moveTo (state, {feedGroupIndex, oldIndex, newIndex}) {
      const feed = state.feeds[feedGroupIndex]

      while (oldIndex < 0) {
        oldIndex += feed.length
      }
      while (newIndex < 0) {
        newIndex += feed.length
      }
      if (newIndex >= feed.length) {
        let k = newIndex - feed.length + 1
        while (k--) {
          feed.push(undefined)
        }
      }
      feed.splice(newIndex, 0, feed.splice(oldIndex, 1)[0])
    },
    addFeedGroup (state, {feedGroupIndex, template}) {
      const name = {
        name: 'name',
        type: 'name',
        value: '',
        visible: true,
        public: true
      }

      const feed = template.map(({name, type}) => {
        let value

        switch (type) {
          case 'list':
            value = []
            break
          case 'number':
            value = 0
            break
          default:
            value = ''
            break
        }

        return {
          name: name,
          type: type,
          value: value
        }
      })

      feed.splice(0, 0, name)
      state.feeds[feedGroupIndex].splice(1, 0, feed)
    },
    updateInput (state, {value, key, feedGroupIndex, feedIndex, inputIndex}) {
      const feeds = state.feeds
      const feedGroup = feeds[feedGroupIndex]
      const feed = feedGroup[feedIndex]
      const input = feed[inputIndex]
      input[key] = value
    },
    currentFeed (state, index) {
      state.currentFeed = index
    },
    changesFound (state, changed) {
      state.changesFound = changed
    }
  }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js